import { GlobalState } from "context/GlobalContext";
import React, { useState } from "react";
import { pythonVmInstance } from "utils/AxiosInstances/RareboxPythonInstance";
import RenderInputField from "components/EboStoreV4/CommonComponents/RenderInputFiled/RenderInputFiled";
import QueryFilterPanel from "components/CustomQueriesDashboard/ReusableComponents/QueryFilterPanel/QueryFilterPanel";
import { filterColArry } from "./data";
import { getColDefaultValue, isColumnDefault } from "components/EboStoreV4/data";
import FileSaver from "file-saver";
import { constraintsOptions } from "data/globalData";

const CustomerCohortCount = () => {
	const { setSnackBar, snackBar, setSnackBarOpen } = GlobalState();
	const [loading, setLoading] = useState(false);

	const defaultData = filterColArry?.reduce((acc, row) => {
		acc[row.key] = getColDefaultValue(row);
		return acc;
	}, {});
	const [filterData, setFilterData] = useState({ ...defaultData });

	const handleRunQueryClick = async (e) => {
		e.preventDefault();
		setLoading(true);
		let pendingFields = [];
		filterColArry?.forEach((attr) => {
			if (isColumnDefault(attr, filterData?.[attr?.key]) && attr?.constraints?.[constraintsOptions.NOTNULL.key] === true)
				pendingFields.push(attr);
		});

		if (pendingFields?.length) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: `Enter values for ${pendingFields.map((row) => row?.name)}`,
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoading(false);
			return;
		}

		try {
			await pythonVmInstance({
				url: `/custom_queries/customer_cohort`,
				headers: {
					"Content-Type": "application/json",
				},
				method: "post",
				responseType: "blob",
				data: {
					...filterData,
					type: ["CUSTOMER_MOBILE"],
				},
			}).then((res) => {
				const url = URL.createObjectURL(res.data);
				FileSaver.saveAs(url, `customer-count/${new Date().toISOString().split("T")[0]}.xlsx`);
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: "Downloaded the file",
					severity: "success",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
				setLoading(false);
			});
		} catch (error) {
			setSnackBarOpen(true);
			console.log("asdfghjkl", error);
			setSnackBar({
				...snackBar,
				message: `failed to run query ${error}`,
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoading(false);
		}
	};

	return (
		<QueryFilterPanel onSubmit={handleRunQueryClick} loading={loading} submitLabel="Download">
			{filterColArry?.map((col) => (
				<RenderInputField
					key={col.key}
					column={col}
					data={filterData}
					setData={setFilterData}
					selectOptObjName={"select_options"}
					width={"100%"}
					longWidth={"300px"}
					disabled={false}
				/>
			))}
		</QueryFilterPanel>
	);
};

export default CustomerCohortCount;
